// import external modules
import { combineReducers } from "redux";

import { reducer as toastrReducer } from "react-redux-toastr";
import customizer from "./customizer/";
import { reducer as ReducerForm } from "redux-form";
import auth from "./authentication/auth";
import team from "./team/team";
import institutions from "./institutions/institutions";
import annees from "./annees/annees";
import classes from "./classes/classes";
import annexes from "./fraisAnnexe/annexes";
import inscriptions from "./inscriptions/inscriptions";
import etudiants from "./etudiants/etudiants";
import canaux from "./canaux/canaux";
import visites from "./visites/visites";
import tasks from "./tasks/tasks";

const rootReducer = combineReducers({
  toastr: toastrReducer, // <- Mounted at toastr.
  customizer: customizer,
  form: ReducerForm,
  auth,
  team,
  institutions,
  annees,
  classes,
  annexes,
  inscriptions,
  etudiants,
  canaux,
  visites,
  tasks,
});

export default rootReducer;
